<template>
  <v-card>
    <s-crud
      ref="crud"
      :config="config"
      title="Instituciones Educativas"
      :filter="filter"
      add
      edit
      remove
      @save="save($event)"
    >
      <template v-slot:options>
        <v-btn small color="success" class="mx-1" @click="dialogUpload = true">
          <v-icon left>mdi-cloud-upload</v-icon> Carga Masiva (Excel)
        </v-btn>
      </template>

      <template v-slot:filter>
        <v-container>
          <!-- No filters needed for now, or simple text search is built in s-crud -->
        </v-container>
      </template>

      <template v-slot="props">
        <v-container>
          <v-row dense>
            <v-col cols="12" md="6" class="s-col-form">
              <s-text
                label="Nombre de la Institución*"
                v-model="props.item.EdiDescription"
              />
            </v-col>
            <v-col cols="12" md="6" class="s-col-form">
              <s-text
                label="Código SUNAT*"
                v-model="props.item.EdiCode"
              />
            </v-col>
            <v-col cols="12" md="6" class="s-col-form">
              <s-select-definition
                v-model="props.item.TypeRegEdu"
                :def="1714"
                label="Régimen Educativo*"
              />
            </v-col>
            <v-col cols="12" md="6" class="s-col-form">
              <s-select-definition
                v-model="props.item.TypeInstitution"
                :def="1715"
                label="Tipo de Institución*"
              />
            </v-col>
          </v-row>
        </v-container>
      </template>
    </s-crud>

    <!-- Dialogo de Carga Masiva desde Excel -->
    <v-dialog v-model="dialogUpload" max-width="800" persistent>
      <v-card>
        <s-toolbar label="Carga Masiva de Instituciones Educativas" dark color="success" close @close="closeUploadDialog()" />
        <v-card-text class="pt-4">
          <v-row>
            <v-col cols="12">
              <v-file-input
                label="Seleccione archivo Excel"
                accept=".xlsx,.xls"
                v-model="excelFile"
                outlined
                dense
                @change="onFileChange"
              />
            </v-col>
          </v-row>

          <v-card v-if="columns.length > 0" outlined class="pa-4 mt-2">
            <div class="subtitle-2 mb-3 font-weight-bold grey--text text--darken-2">Mapeo de Columnas (Excel):</div>
            <v-row dense class="mb-3">
              <v-col cols="12" md="6">
                <s-text type="number" label="Fila de Inicio (Fila de Datos)" v-model="startRow" />
              </v-col>
            </v-row>

            <v-simple-table dense class="elevation-1">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Columna Destino</th>
                    <th class="text-left">Mapear desde Excel</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="font-weight-medium">Nombre de Institución (C. INSTITUC)</td>
                    <td>
                      <v-select
                        :items="columns"
                        v-model="mapping.EdiDescription"
                        placeholder="Seleccionar..."
                        dense
                        hide-details
                        outlined
                      />
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-medium">Código SUNAT (COD. INSTITUCIÓN)</td>
                    <td>
                      <v-select
                        :items="columns"
                        v-model="mapping.EdiCode"
                        placeholder="Seleccionar..."
                        dense
                        hide-details
                        outlined
                      />
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-medium">Régimen Educativo (Cod. Tipo Reg)</td>
                    <td>
                      <v-select
                        :items="columns"
                        v-model="mapping.TypeRegEdu"
                        placeholder="Seleccionar..."
                        dense
                        hide-details
                        outlined
                      />
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-medium">Tipo de Institución (COD. TIPO INST.)</td>
                    <td>
                      <v-select
                        :items="columns"
                        v-model="mapping.TypeInstitution"
                        placeholder="Seleccionar..."
                        dense
                        hide-details
                        outlined
                      />
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-card-text>
        <v-card-actions class="pb-4 px-6">
          <v-spacer />
          <v-btn color="error" text @click="closeUploadDialog">Cancelar</v-btn>
          <v-btn color="success" :loading="loadingUpload" :disabled="!excelFile || !mapping.EdiDescription" @click="processUpload">
            <v-icon left>mdi-cloud-upload</v-icon> Procesar e Importar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import SText from '@/components/Utils/SText.vue';
import SSelectDefinition from '@/components/Utils/SSelectDefinition.vue';
import ServiceEducationalInstitution from '@/services/HumanResource/HmnEducationalInstitution';
import ExcelJS from 'exceljs';

export default {
  name: 'HmnEducationalInstitution',
  components: {
    SText,
    SSelectDefinition
  },
  data() {
    return {
      filter: {},
      config: {
        service: ServiceEducationalInstitution,
        model: {
          EdiID: 'ID'
        },
        headers: [
          { text: 'ID', value: 'EdiID' },
          { text: 'Nombre de la Institución', value: 'EdiDescription' },
          { text: 'Código SUNAT', value: 'EdiCode' },
          { text: 'Régimen Educativo', value: 'TypeRegEduText' },
          { text: 'Tipo de Institución', value: 'TypeInstitutionText' }
        ]
      },
      dialogUpload: false,
      excelFile: null,
      columns: [],
      startRow: 2,
      mapping: {
        EdiDescription: null,
        EdiCode: null,
        TypeRegEdu: null,
        TypeInstitution: null
      },
      loadingUpload: false,
      parsedRows: []
    };
  },
  methods: {
    save(item) {
      if (!item.EdiDescription || item.EdiDescription.trim().length === 0) {
        this.$fun.alert('El campo Nombre de la Institución es obligatorio', 'warning');
        return;
      }
      item.save();
    },
    async onFileChange(file) {
      if (!file) {
        this.columns = [];
        this.parsedRows = [];
        return;
      }
      try {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const buffer = e.target.result;
          const workbook = new ExcelJS.Workbook();
          await workbook.xlsx.load(buffer);
          const worksheet = workbook.worksheets[0];
          if (!worksheet) {
            this.$fun.alert('El Excel no tiene hojas', 'warning');
            return;
          }

          // Pre-parse the worksheet columns from row 1
          const cols = [];
          const headerRow = worksheet.getRow(1);
          const totalCols = Math.max(15, worksheet.columnCount || 0);
          for (let i = 1; i <= totalCols; i++) {
            const cellVal = headerRow.getCell(i).value;
            const letter = this.getColumnLetter(i);
            const label = cellVal ? `${letter} - ${cellVal}` : `${letter} (Columna ${i})`;
            cols.push({ value: i, text: label });
          }
          this.columns = cols;

          // Auto map columns if headers match keywords
          this.autoMapColumns(headerRow, totalCols);

          // Save worksheet reference to parse when uploaded
          this.parsedRows = [];
          worksheet.eachRow((row, rowNumber) => {
            const rowData = [];
            row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
              rowData[colNumber] = cell.value;
            });
            this.parsedRows.push({ rowNumber, values: rowData });
          });
        };
        reader.readAsArrayBuffer(file);
      } catch (err) {
        console.error(err);
        this.$fun.alert('Error al leer el archivo Excel', 'error');
      }
    },
    getColumnLetter(colIndex) {
      let temp, letter = '';
      while (colIndex > 0) {
        temp = (colIndex - 1) % 26;
        letter = String.fromCharCode(65 + temp) + letter;
        colIndex = (colIndex - temp - 1) / 26;
      }
      return letter;
    },
    autoMapColumns(headerRow, totalCols) {
      // Simple automapping logic based on headers
      for (let i = 1; i <= totalCols; i++) {
        const cellVal = String(headerRow.getCell(i).value || '').toUpperCase().trim();
        if (cellVal.includes('C. INSTITUC') || cellVal.includes('NOMBRE') || cellVal.includes('UNIVERSIDAD')) {
          this.mapping.EdiDescription = i;
        } else if (cellVal.includes('COD. INSTITUC') || cellVal.includes('CODIGO') || cellVal.includes('CÓDIGO') || cellVal.includes('COD. INSTITUCIÓN')) {
          this.mapping.EdiCode = i;
        } else if (cellVal.includes('REG') || cellVal.includes('REGIMEN') || cellVal.includes('RÉGIMEN') || cellVal.includes('REG. EDU')) {
          this.mapping.TypeRegEdu = i;
        } else if (cellVal.includes('TIPO INST') || cellVal.includes('TIPO') || cellVal.includes('TIPO INSTITUCION')) {
          this.mapping.TypeInstitution = i;
        }
      }
    },
    closeUploadDialog() {
      this.dialogUpload = false;
      this.excelFile = null;
      this.columns = [];
      this.startRow = 2;
      this.mapping = {
        EdiDescription: null,
        EdiCode: null,
        TypeRegEdu: null,
        TypeInstitution: null
      };
      this.loadingUpload = false;
      this.parsedRows = [];
    },
    processUpload() {
      if (!this.mapping.EdiDescription) {
        this.$fun.alert('Debe mapear al menos el Nombre de la Institución', 'warning');
        return;
      }

      this.$fun.alert('¿Seguro de importar las instituciones del archivo Excel?', 'question').then((r) => {
        if (r.value) {
          this.loadingUpload = true;

          const dataToUpload = [];
          const start = parseInt(this.startRow) || 2;

          // Parse rows based on the mappings
          for (let i = 0; i < this.parsedRows.length; i++) {
            const row = this.parsedRows[i];
            if (row.rowNumber < start) continue;

            const descVal = row.values[this.mapping.EdiDescription];
            if (!descVal || String(descVal).trim().length === 0) continue;

            const codeVal = this.mapping.EdiCode ? row.values[this.mapping.EdiCode] : null;
            const regVal = this.mapping.TypeRegEdu ? row.values[this.mapping.TypeRegEdu] : null;
            const instVal = this.mapping.TypeInstitution ? row.values[this.mapping.TypeInstitution] : null;

            dataToUpload.push({
              EdiDescription: String(descVal).trim(),
              EdiCode: codeVal ? String(codeVal).trim() : null,
              TypeRegEdu: regVal ? parseInt(regVal) || null : null,
              TypeInstitution: instVal ? parseInt(instVal) || null : null
            });
          }

          if (dataToUpload.length === 0) {
            this.loadingUpload = false;
            this.$fun.alert('No se encontraron filas con datos válidos para procesar.', 'warning');
            return;
          }

          ServiceEducationalInstitution.upload(dataToUpload, this.$fun.getUserID())
            .then((response) => {
              this.loadingUpload = false;
              const msg = response.data.message || 'Importación exitosa';
              this.$fun.alert(msg, 'success');
              this.closeUploadDialog();
              this.$refs.crud.refresh();
            })
            .catch((err) => {
              this.loadingUpload = false;
              const errorMsg = err.response?.data?.Message || err.message || 'Error al subir';
              this.$fun.alert(errorMsg, 'error');
            });
        }
      });
    }
  }
};
</script>

<style scoped>
</style>
